const SET_USER = 'SET_USER';
const REMOVE_USER = 'REMOVE_USER';
const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
const FETCH_USER_ERROR = 'FETCH_USER_ERROR';

export { SET_USER, REMOVE_USER, FETCH_USER_REQUEST, FETCH_USER_SUCCESS, FETCH_USER_ERROR };
